import { render, staticRenderFns } from "./NewYagiofferEduHistoryCard.vue?vue&type=template&id=c2f35204"
import script from "./NewYagiofferEduHistoryCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./NewYagiofferEduHistoryCard.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports